module.exports = __webpack_public_path__ + "img/ccv.1e913fd4.svg";